<template>
    <div>
        <div class="columns is-centered is-multiline m-b-20" style="border-bottom:0.8px #ddd solid;">
            
            <div class="column is-two-thirds has-text-centered">
                <a class="has-text-danger is-size-6"
                @click="deleteSlide">
                    <b-icon icon="trash" size="is-small"></b-icon>
                    Delete
                </a>
                <b-field label="Imagen">
                    <b-upload
                        v-model="image"
                        drag-drop
                        @input="encodeImage"
                        >
                        <section class="section" >
                            <div class=" has-text-centered">
                                <p>
                                    <b-icon
                                        icon="upload"
                                        size="is-large">
                                    </b-icon>
                                </p>
                                <p>Arrastra aqui tus archivos o haz click.</p>
                            </div>
                        </section>
                    </b-upload>
                </b-field>

                <div v-if="image" class="tags">
                    <span
                        class="tag is-primary" >
                        {{image.name}}
                        <button class="delete is-small"
                            type="button"
                            @click="deleteDropFile">
                        </button>
                    </span>
                </div>

            </div>
            <div class="column is-two-thirds">
                <b-field label="Titulo/descripcion">
                    <b-input
                    v-model="data.caption">
                    </b-input>
                </b-field>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            image:""
        }
    },
    props:{
        data:{
            type: Object,
            default: new Object({})
        },
        newSlide:{
            type:Boolean,
            default:false
        },
        index:{
            type:Number,
            default:0
        }
    },
    methods:{
        encodeImage(){
            let reader = new FileReader();
            reader.readAsDataURL(this.image);
            reader.onloadend = (event) => {
                this.data.image = reader.result
            }
        },
        deleteDropFile(){
            this.image = ""
            this.data.image = ""
        },
        deleteSlide(){
            this.$emit("deleteElement", {isNew:this.newSlide, index:this.index})
        }
    },
    

}
</script>
